import { Popover } from '@radix-ui/themes';
import classNames from 'classnames';

export enum ActivePopoverColor {
  YELLOW = 'yellow',
  GREEN = 'green',
}

export const ActivePopover: React.FC<{ big: boolean; color: ActivePopoverColor }> = ({ big, color }) => (
  <Popover.Root>
    <Popover.Trigger>
      <div
        className={classNames(
          'border-neutral-neutral-1 absolute top-0 right-0 rounded-full border-2',
          { 'h-4 w-4': big },
          { 'h-2 w-2': !big },
          {
            'bg-green-9': color === ActivePopoverColor.GREEN,
          },
          { 'bg-yellow-9': color === ActivePopoverColor.YELLOW },
        )}
      />
    </Popover.Trigger>
    <Popover.Content maxWidth='300px' className='bg-neutral-neutral-11'>
      <div className='text-accent-accent-6 text-xs'>
        Utente connesso nelle ultime {ActivePopoverColor.GREEN ? ' ore' : ' settimane'}
      </div>
    </Popover.Content>
  </Popover.Root>
);

export default ActivePopover;
